import { SearchForm } from "@/component-create/SearchForm"
import { createFormItem } from "@/component-create/utils/create-form-item"
import { FORM_ITEM } from "@/components/form/enums"

export function renderMessageSearchForm(el: Element) {
  const searchForm = new SearchForm(el, items, { labelWidth: '80px' })

  return searchForm
}

const items = [
  createFormItem('主题', 'subject', FORM_ITEM.INPUT, { clearable: true, maxlength: '20' }),
  createFormItem('类型', 'type', FORM_ITEM.SELECT, { 
    loader: 'MESSAGE_TYPE', 
    allOption: true, 
    default: true, 
    defaultOnNull: true 
  }),
  createFormItem('状态', 'status', FORM_ITEM.SELECT, { 
    loader: 'MESSAGE_STATUS', 
    allOption: true, 
    default: true, 
    defaultOnNull: true 
  }),
]